import { createFileRoute } from "@tanstack/react-router";
import AdminEmailDetailPage from "@/admin/pages/email-detail";

export const Route = createFileRoute("/admin/email/$id")({
  component: AdminEmailDetailPage,
});
